module.exports = __webpack_public_path__ + "static/img/online_row1_icon3.9cf07795.png";